(function () {
  var config = window.SpecialSaleConfig;
  var modal = document.querySelector("[special-sale-popup]");
  if (!config || !modal) return;
  if (window.__specialSalePopupInitialized) return;
  window.__specialSalePopupInitialized = true;

  var sourceHandles = (config.collectionHandles && config.collectionHandles.length) ? config.collectionHandles : [];
  if (!sourceHandles.length) return;

  var collectionIds = null;
  var collectionHandles = null;
  var collectionProductIdsPromise = null;
  var armedProduct = null;
  var hideTimer = null;

  function hidePopup() {
    modal.style.display = "none";
  }

  function showPopup() {
    modal.style.display = "flex";
  }

  function popupIsOpen() {
    return modal.style.display === "flex";
  }

  function smartCart() {
    return window.Rebuy && window.Rebuy.SmartCart;
  }

  function drawerIsOpen() {
    return document.body.classList.contains("rebuy-cart-visible") || !!document.querySelector("#rebuy-cart.is-visible");
  }

  // Clears both a pending timeout and a running interval
  function stopHoldingDrawer() {
    if (hideTimer) {
      window.clearInterval(hideTimer);
      window.clearTimeout(hideTimer);
      hideTimer = null;
    }
  }

  function closeQuickView() {
    if (!document.body.classList.contains("theme-modal-open") || !window.eventBus) return;
    window.eventBus.emit("theme:modal:hide");
  }

  // Retries until the drawer is actually open (handles quick view closing late
  // or the theme re-setting shouldPreventCartOpen after the add).
  function showDrawer(initialDelay) {
    stopHoldingDrawer();
    closeQuickView();

    var tries = 0;

    function attempt() {
      window.shouldPreventCartOpen = false;

      if (drawerIsOpen()) {
        stopHoldingDrawer();
        return;
      }

      // quick view still open/closing? close it again
      if (document.body.classList.contains("theme-modal-open")) closeQuickView();

      var cart = smartCart();
      if (cart && typeof cart.show === "function") cart.show();
    }

    function start() {
      attempt();
      hideTimer = window.setInterval(function () {
        tries += 1;
        if (tries > 20) {
          stopHoldingDrawer();
          return;
        }
        attempt();
      }, 100);
    }

    if (initialDelay) {
      hideTimer = window.setTimeout(start, initialDelay);
    } else {
      start();
    }
  }

  function holdDrawerWhilePopupOpen() {
    stopHoldingDrawer();
    var tries = 0;
    hideTimer = window.setInterval(function () {
      tries += 1;
      if (!popupIsOpen() || tries > 40) {
        stopHoldingDrawer();
        return;
      }
      var cart = smartCart();
      if (drawerIsOpen() && cart && typeof cart.hide === "function") cart.hide();
    }, 50);
  }

  function showSalePopup() {
    closeQuickView();
    showPopup();
    var cart = smartCart();
    if (cart && typeof cart.hide === "function") cart.hide();
    holdDrawerWhilePopupOpen();
  }

  function continueShopping() {
    hidePopup();
    showDrawer();
  }

  function shopBoards(event) {
    event.preventDefault();
    var url = event.currentTarget.getAttribute("href");
    var cart = smartCart();

    hidePopup();
    stopHoldingDrawer();
    window.shouldPreventCartOpen = false;
    if (cart && typeof cart.show === "function") cart.show();
    if (cart && typeof cart.hide === "function") cart.hide();
    window.location.assign(url);
  }

  var closeButton = modal.querySelector(".close");
  var continueButton = modal.querySelector("[data-special-sale-continue]");
  var shopButton = modal.querySelector("[data-special-sale-shop]");
  if (closeButton) closeButton.addEventListener("click", continueShopping);
  if (continueButton) continueButton.addEventListener("click", continueShopping);
  if (shopButton) shopButton.addEventListener("click", shopBoards);

  function routesRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
  }

  function loadCollectionProducts() {
    if (collectionProductIdsPromise) return collectionProductIdsPromise;

    var ids = {};
    var handles = {};

    function loadHandlePages(handle, page) {
      return fetch(routesRoot() + "collections/" + encodeURIComponent(handle) + "/products.json?limit=250&page=" + page, {
        headers: { Accept: "application/json" }
      })
        .then(function (response) {
          if (!response.ok) throw new Error("Unable to read trigger collection");
          return response.json();
        })
        .then(function (data) {
          var products = data.products || [];
          products.forEach(function (product) {
            if (!product) return;
            if (product.id) ids[String(product.id)] = true;
            if (product.handle) handles[product.handle] = true;
          });
          if (products.length === 250) return loadHandlePages(handle, page + 1);
        });
    }

    function loadAt(index) {
      if (index >= sourceHandles.length) return { ids: ids, handles: handles };
      return loadHandlePages(sourceHandles[index], 1).catch(function () {}).then(function () {
        return loadAt(index + 1);
      });
    }

    collectionProductIdsPromise = loadAt(0)
      .then(function (loaded) {
        collectionIds = loaded.ids;
        collectionHandles = loaded.handles;
        return loaded;
      })
      .catch(function () {
        collectionProductIdsPromise = null;
        return null;
      });

    return collectionProductIdsPromise;
  }

  function isTriggerProduct(product, ids, handles) {
    if (!product || !ids) return false;
    if (product.id && ids[String(product.id)]) return true;
    if (product.handle && handles && handles[product.handle]) return true;
    return false;
  }

  function handleAddResult(product, loaded) {
    if (loaded && isTriggerProduct(product, loaded.ids, loaded.handles)) {
      showSalePopup();
      return;
    }

    hidePopup();
    showDrawer(150); // small delay so Rebuy's own open happens first
  }

  document.addEventListener("submit", function (event) {
    var form = event.target;
    if (!form || !form.getAttribute || form.getAttribute("data-type") !== "add-to-cart-form") return;

    var productForm = form.closest("product-form");
    if (!productForm) return;

    armedProduct = {
      id: productForm.getAttribute("data-special-sale-product-id") || "",
      handle: productForm.getAttribute("data-special-sale-product-handle") || ""
    };
  }, true);

  document.addEventListener("rebuy:cart.add", function () {
    if (!armedProduct) return;

    var product = armedProduct;
    armedProduct = null;

    if (collectionIds) {
      handleAddResult(product, { ids: collectionIds, handles: collectionHandles });
      return;
    }

    loadCollectionProducts().then(function (loaded) {
      handleAddResult(product, loaded);
    });
  });

  loadCollectionProducts();
})();